import { Controller } from "@hotwired/stimulus"

// Synchronizuje end_time przy zmianie start_time, dopóki user nie tknął końca ręcznie.
// Strategia: trzymamy poprzednią wartość startu i przesuwamy koniec o taką samą różnicę,
// dzięki czemu użytkownik zachowuje długość wydarzenia po zmianie daty/godziny początku.
export default class extends Controller {
  static targets = ["startTime", "endTime"]

  connect() {
    this.previousStart = this.startTimeTarget.value
    this.userEditedEnd = false
  }

  // user kliknął i zmienił koniec ręcznie - nie nadpisujemy go już
  markEndEdited() {
    this.userEditedEnd = true
  }

  syncEndTime() {
    const newStart = this.startTimeTarget.value
    if (!newStart) return

    const newStartDate = this.parseLocal(newStart)
    if (!newStartDate) return

    if (!this.userEditedEnd) {
      const oldStart = this.previousStart
      const oldEnd = this.endTimeTarget.value

      let newEndDate
      if (oldStart && oldEnd) {
        const oldStartDate = this.parseLocal(oldStart)
        const oldEndDate = this.parseLocal(oldEnd)
        if (oldStartDate && oldEndDate) {
          const deltaMs = newStartDate.getTime() - oldStartDate.getTime()
          newEndDate = new Date(oldEndDate.getTime() + deltaMs)
        }
      }
      if (!newEndDate) {
        newEndDate = new Date(newStartDate.getTime() + 60 * 60 * 1000)
      }

      this.setEndDate(newEndDate)
    }

    this.previousStart = newStart
  }

  // oba pola są pod kontrolą flatpickra (format "YYYY-MM-DD HH:MM"),
  // ale parser akceptuje też wariant z separatorem T (np. datetime-local)
  parseLocal(value) {
    if (!value) return null
    const normalized = value.replace(" ", "T")
    const date = new Date(normalized)
    return Number.isNaN(date.getTime()) ? null : date
  }

  // ustawiamy datę końca przez flatpickr API (żeby zsynchronizował state),
  // a w testach (bez DOM/flatpickr) fallback na bezpośrednie value
  setEndDate(date) {
    const picker = this.endTimeTarget._flatpickr
    if (picker) {
      picker.setDate(date, false)
    } else {
      this.endTimeTarget.value = this.formatLocal(date)
    }
  }

  // format zgodny z flatpickrem: "YYYY-MM-DD HH:MM" (lokalny - bez strefy)
  formatLocal(date) {
    const pad = (n) => String(n).padStart(2, "0")
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}`
  }
}
